import * as React from 'react';

export const SvgLinkedin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 18" {...props}>
    <path
      fill="#007EBB"
      fillRule="evenodd"
      d="M19.8 18h-4.376v-6.328c0-1.656-.685-2.787-2.19-2.787-1.151 0-1.791.763-2.09 1.499-.111.264-.094.631-.094.999V18H6.715s.056-11.209 0-12.228h4.335v1.92c.256-.84 1.642-2.037 3.852-2.037 2.743 0 4.898 1.758 4.898 5.546V18zM2.33 4.243h-.027C.906 4.243 0 3.308 0 2.123 0 .915.932 0 2.357 0c1.424 0 2.3.913 2.328 2.12 0 1.184-.904 2.123-2.354 2.123zM.5 5.773h3.859V18H.499V5.772z"
    />
  </svg>
);
